import React from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import './ReflectAndIntegrate4.scss';

export default function ReflectAndIntegrate4({ apiData, previewData, reportType, pageNumber }) {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)", }}>
      <HeaderPreview apiData={apiData} />
      <div className="reflect-and-integrate4-container">
        <div>
          <h2 className="final-thoughts-heading">FINAL THOUGHTS</h2>
          <p>
            Thank you for investing your time and energy in reviewing your Quadrant Flow™ assessment. Awareness
            is the first step—but transformation happens when you take action.
          </p>
          <p>
            We encourage you to revisit your insights regularly, reflect deeply, and connect with your coach or consultant to map out meaningful next steps. This journey isn’t about perfection—it’s about alignment. Becoming the kind of leader whose life and leadership are fully integrated.
          </p>
          <p>Your growth doesn’t just impact you. It shapes the culture, people, and outcomes around you. Keep going. The work you’re doing matters.
          </p>
          <p className='para'>WANT TO GO DEEPER?
          </p>
          <a>VISIT WWW.TRANSFORMEDLEADER.COM
          </a>
          <p className="body-text">
            © 2025 Dr. Rob Murray & Jack Nicholson. Published by Transformed Leader. All rights reserved. Heart, Soul, Mind, and Strength™, Quadrant Flow™, The Human Operating System™, the Strength Index™, and all related frameworks and models are trademarks of Dr. Rob Murray & Jack Nicholson. No part of this report may be reproduced, distributed, or adapted in any form without explicit written permission. For licensing, certification, or practitioner use, contact us at www.transformedleader.com.</p>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
